import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

import QueryDef from './query/QueryDef';
import { Tab,Tabs } from '@blueprintjs/core';

import SavedResults from '../corpus/savedResults/SavedResults';
import SavedQueries from '../corpus/savedQueries/SavedQueries';
import './Search.css';
import { refreshSignIn } from '../../utils'


/* `Search` is a rather shallow component logic-wise, because
 * it just passes down the functions it receives from `Dashboard`.
 * Note: it's `QueryDef` which is responsible for starting
 * the query by calling `onQueryReady` received by props.
 */
class Search extends React.PureComponent {

  state = {
    selectedTabId:'query',
    savedResults:[],
    savedQueries:{},    
  };

  componentDidMount() {
    this.fetchUserData();
  }

  handleTabChange = (selectedTabId) => {
    this.setState({selectedTabId:selectedTabId});
  }

  refreshSavedData=() => {
    return this.fetchUserData();
    //console.log("Refresh !");
  }

  pasteQueryWithTabChange = (q) => {
    this.props.pasteQuery(q);
    this.setState( { selectedTabId:'query' } );
  }

  async fetchUserData( ) {
    const endpoint = '/get_archives.ajax.php';

    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
      })
      .then((res) => {
        if (res.status === 201) {
          // raffraichissement automatique du login si la session est tombée
          console.log(`Refreshing signing in after logged out`);
          refreshSignIn();
          return;
        }
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        
        res.json().then((data) => {
          this.setState({ 
              savedResults: data.results,
              savedQueries: data.queries
          });
          return data;
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })

  }

 
  render() {
    const { t } = this.props;
    const selectedTabId=this.state.selectedTabId;

    // if get data allows to define collection and language, then no way back to corpus selection
    
    //const urlParams = new URLSearchParams(window.location.search);
    //const collection = urlParams.get('collection');
    //const lang = urlParams.get('lang');

    const name=this.props.corpus?
      (typeof this.props.corpus.name === "string") ? this.props.corpus.name:
        ((typeof this.props.corpus.name === "object") ? this.props.corpus.name.join(", "):"")
      :"";


    const queryTab= <>
                      <div className="flex flex-between Search__topSection">
                          <div className="Search__FlexBox">
                              <p>{t('selectedCorpus')} : {name}</p>
                          </div>
                      </div>

                      <img
                        src={process.env.PUBLIC_URL + '/assets/img/lexicoscope.png'}
                        alt="Lexicoscope"
                        className="largeLogo"
                      />

                      <QueryDef
                        onQueryReady={this.props.onQueryReady}
                        corpus={this.props.corpus}
                        params={this.props.params}
                        pastedQuery={this.props.pastedQuery}
                        clearPastedQuery={this.props.clearPastedQuery}
                      />
                    </>;

      const savedResultsTab=<SavedResults
                              loadSavedResults={this.props.loadSavedResults}
                              savedResults={this.state.savedResults}
                              refreshSavedData={this.refreshSavedData}
                            />    
      const savedQueriesTab=<SavedQueries
                            savedQueries={this.state.savedQueries}
                            refreshSavedData={this.refreshSavedData}
                            pasteQuery={this.pasteQueryWithTabChange}
                          />                                                         

    return (
      <>
        {/* renderActiveTabPanelOnly not optimal : only way to refresh saved corpus list : todo use state variable to trigger list reloading */}
        <Tabs onChange={this.handleTabChange} selectedTabId={selectedTabId}>
          <Tab id='query' title={t('query')} panel={queryTab} />
          <Tab id='savedQueries' title={t('savedQueries')} panel={savedQueriesTab} />
          <Tab id='savedResults' title={t('savedResults')} panel={savedResultsTab} />
        </Tabs>
      </>
    );


  }
}

Search.propTypes = {
  onQueryReady: PropTypes.func,
  corpus: PropTypes.object,
  onBackToCorpus: PropTypes.func,
  pastedQuery: PropTypes.string,
  clearPastedQuery:PropTypes.func,
  loadSavedResults: PropTypes.func, 
  refreshSavedData: PropTypes.func,
  pasteQuery:PropTypes.func
};

export default withTranslation()(Search);
